<template>
  <section class="whiteBox">
    <div class="content">
      <div
        class="row spaceBetween"
        v-if="parUserPageRights"
      >
        <p class="accentuate">{{$t('users.users')}}</p>
        <button
          class="outline"
          @click="addUser = true"
        >{{$t('button.addUser')}}</button>
      </div>
      <div
        v-else
        class="row spaceBetween"
      >
      </div>
      <div class="row">
        <table>
          <thead>
            <tr>
              <th>{{$t('users.user')}}</th>
              <th>{{$t('users.role')}}</th>
              <th>{{$t('users.campaignAccess')}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="user in userList"
              :key="user.id"
            >
              <td>{{user["first-name"]}} {{user["name"]}}</td>
              <td>{{user["user-profile-name"]}}</td>
              <td>
                <p
                  class="comments"
                  v-if="user['all-campaigns-access']"
                >{{$t('users.allCampaignsAccess')}}</p>
                <p
                  v-else
                  class="comments"
                >{{$t('users.limitedCampaignsAccess')}}</p>
              </td>
              <td class="bubbleParent">
                <button
                  ref="bubble"
                  class="outline"
                  @click="bubbleClick('user'+user.id)"
                >
                  <img
                    ref="bubble"
                    class="pastille"
                    src="@/assets/images/pastille.png"
                    alt="pastille"
                  >
                </button>
                <div
                  class="bubble"
                  v-if="bubbleAction('user'+user.id)"
                >
                  <a @click="diplayUserDetailsbyId(user.id)">{{$t('button.userDetails')}}</a>
                  <a
                    class="redText"
                    v-if="!user['all-campaigns-access']&&parUserPageRights"
                    @click="removeUser(user.id)"
                  >{{$t('button.revoqueUser')}}</a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Add user display -->
    <AddUserToCampaign
      v-if="addUser"
      :parCampaignId="this.parCampaignId"
      :parUserList="this.userList"
      @close="addUser = false"
      @newuseradded="newUserAdded()"
    ></AddUserToCampaign>

    <!-- user details display -->
    <UserDetails
      v-if="displayUserDetails"
      :parUserId="this.currentUser"
      @close="displayUserDetails = false"
    ></UserDetails>
  </section>

</template>
<script>
import getCampaignDetails from "@/mixins/getCampaignDetails";
import bubble from "@/mixins/bubble";
import UserDetails from "@/components/users/UserDetails";
import generalMethods from "@/mixins/generalMethods";
import AddUserToCampaign from "@/components/campaigns/campaignDetails/AddUserToCampaign";
import Users from "@/services/Users";
export default {
  props: ["parUserPageRights", "parCampaignId"],
  mounted() {
    this.getUserList(this.parCampaignId);
  },
  components: { UserDetails, AddUserToCampaign },
  data() {
    return {
      //Menu management
      addUser: false,
      displayUserDetails: false,
      currentUser: ""
    };
  },
  mixins: [bubble, getCampaignDetails, generalMethods],
  methods: {
    removeUser(id) {
      Users.removeUserFromCampaign(this.$route.params.id, id).then(res => {
        if (res.status == 204) this.getUserList(this.parCampaignId);
      });
    },

    // Over the page display management
    diplayUserDetailsbyId(userid) {
      this.currentUser = userid;
      this.displayUserDetails = true;
    },
    newUserAdded() {
      this.addUser = false;
      this.getUserList(this.parCampaignId);
    }
  }
};
</script>
<style scoped>
</style>